import { render, staticRenderFns } from "./ListTicket.vue?vue&type=template&id=b594f10a"
import script from "./ListTicket.vue?vue&type=script&lang=ts"
export * from "./ListTicket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports